import { defineTransform } from '@client/core/data/concerns/parses-from-json';
import { Nullable } from '@client/core/data/types';

export class InvestmentPacketFields {
  constructor(
    public readonly coverPhotoUrl: Nullable<string>,
    public readonly estimateSummary: Nullable<string>,
    public readonly executiveSummaryPhotoIds: number[],
    public readonly packetPhotos: string[],
    public readonly reportTitle: Nullable<string>,
    public readonly selectedCategories: string[],
    public readonly compsReportNotes: Nullable<string>,
  ) {}
}

defineTransform(InvestmentPacketFields, (json, { fromSnakeCaseKeys }) => {
  return fromSnakeCaseKeys();
});
